<template>

  <div class="user">
    <!--搜索表单-->
    
    <!--添加商家-->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick" v-auth="'/plus/adv/adv/add'">添加广告位</el-button>
    </div>
    
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small"  :data="tableData" border style="width: 100%" v-loading="loading">
             <el-table-column prop="adv_id" label="广告位id"></el-table-column>
            <el-table-column prop="name" label="广告位名称" width="150"></el-table-column>
            <el-table-column label="余额价"  >
              <template slot-scope="scope">
              <span v-if="scope.row.price">{{scope.row.price}}/天</span>
            </template>	
            </el-table-column>
            <el-table-column label="积分价"  >
              <template slot-scope="scope">
              <span v-if="scope.row.points">{{scope.row.points}}/天</span>
            </template>	
            </el-table-column>
            <el-table-column prop="adv_limit" label="广告位数量" width="150"></el-table-column>
            <el-table-column prop="adv_wait" label="广告排队数" width="150"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" v-auth="'/plus/adv/adv/delete'" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import AdvApi from '@/api/adv.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      status: ['禁用', '启用']
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      AdvApi.advList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          console.log(self.tableData)
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加活动*/
    addClick() {
      this.$router.push('/plus/adv/adv/add');
    },

    /*编辑活动*/
    editClick(row) {
      let adv_id = row.adv_id;
      this.$router.push({
        path: '/plus/adv/adv/edit',
        query: {
          adv_id: adv_id
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          AdvApi.delAdv(
            {
              adv_id: row.adv_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '商家删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    /* 
    *设置默认供应商
    */
    setAdvDefault(item){
      let self = this;
      let form = {
        'adv_id':item.adv_id,
        'is_default':item.is_default,
        'operation':'setdefault',
      }
      AdvApi.saveAdv(form, true)
      .then(data => {
        self.loading = false;
        
        if (data.code == 1) {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          self.getTableList();
        } else {
          self.loading = false;
        }
      })
      .catch(error => {
        self.loading = false;
      });
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/adv/adv/index.vue